<div class="workSpace">
   <!--nombre y filtro-->
   <div class="w3-container w3-container-template" style="height: 7%;">
    <!--Titulo de modulo y subtitulo-->
    <div class="w3-caja-menu padreizquierda w3-thirty">
      <div class="w3-row hijoizquierda centradoVertical">
        <span class="w3-text-deep-orange w3-margin-right-filter w3-tituloPrincipal"> <b> {{ 'menu.'+dataService.moduleSelect | translate }} </b></span>
        <span class="w3-text-deep-orange">&bull;</span>
        <span class="w3-text-orange w3-margin-left-filter w3-subtituloPrincipal"> {{ 'menu.'+dataService.subModuleSelect | translate }} </span>
      </div>
    </div>
    <!--Filtros-->
    <div class="w3-caja-menu padreizquierda w3-center w3-rest" style="height: 100%">
      <div class="w3-half w3-row centradoVertical w3-center">
      </div>
    </div>
  </div>
  <!-- CONTENIDO TABLERO  -->
  <div class="tablero ">
    <div class="w3-card-4" style="width: 70%; height: fit-content; margin-top: 17vh;" [ngClass]="{'w3-disabled': !descargaDisponible}">
      <div class="w3-row" style="display: flex; align-items: center;">
        <div class="zonaSwitchs" style="margin: 0 1vw;">
          <div>{{'cues.reporte.tit1' | translate}}</div>
          <div class="switchs">
            <div class="togElement ">
              <mat-slide-toggle hideIcon="true" color="primary" labelPosition="before" id="st_introduccion" [(ngModel)]="impAntecedentes">
                <div style="width: 10vw;">{{'cues.reporte.antecedentes' | translate}}</div> 
              </mat-slide-toggle>
            </div>
            <div class="togElement ">
              <mat-slide-toggle hideIcon="true" color="primary" labelPosition="before" id="st_cmp" [(ngModel)]="impComponentes">
                <div style="width: 10vw;">{{'cues.reporte.comp' | translate}}</div> 
              </mat-slide-toggle>
            </div>
            <div class="togElement ">
              <mat-slide-toggle hideIcon="true" color="primary" labelPosition="before" id="st_elem" [(ngModel)]="impElementos" 
              (change)="existenElementos($event)">
                <div style="width: 10vw;">{{'cues.reporte.elem' | translate}}</div> 
              </mat-slide-toggle>
            </div>
          </div>
        </div>
        <div class="zonaTexto" [ngClass]="{'w3-disabled': !impAntecedentes}">
          <div class="instruccionTextArea">{{'cues.reporte.tit2' | translate}}</div>
          <mat-form-field class="textArea example-full-width">
            <mat-label>{{'cues.reporte.antecedentes' | translate}}</mat-label>
            <textarea style="resize: none;" rows="8" matInput id="intro" (input)="onTextAreaChange($event)"></textarea>
          </mat-form-field>
        </div>
      </div>
      
      <div class="zonaBotones w3-row w3-center">
        <button class="boton" mat-flat-button color="success" (click)="guardarIntro();" [ngClass]="{'w3-disabled': !guardarAnte}">{{'cues.reporte.guardar' | translate}}</button>
        <button class="boton" mat-flat-button color="success" (click)="validaDescarga();" [ngClass]="{'w3-disabled': !descargaDisponible}">{{'cues.reporte.descarga' | translate}}</button>
      </div>
  </div>
</div>

<div class="workSpace" style="top: 0; position: absolute; z-index: -1000; overflow: hidden;">
  <div id="grafBarGeneral" style="width: 95%; height: 95%;">
    <div id="graficaBarGeneral"></div>
  </div>
  <!-- <div id="grafRadialGeneral" style="width: 95%; height: 95%;">
    <div id="graficaRadialGeneral"></div>
  </div> -->
  <!-- este div aun no se utiliza en el reporte -->
  <!-- <div id="grafBarComponentes" style="width: 95%; height: 95%;">
    <div id="graficaBarComponentes"></div>
  </div> -->
  @if (questionarySelect) {
    @for (c of questionarySelect['elementos']; track i; let i = $index) {
      <div [id]="'grafCmp'+i" style="width: 95%; height: 95%;">
        <div [id]="'graficaCmp'+i"></div>
      </div>
    }
}
</div>



